<div id="div-register-component" class="register-component">

  <div class="header">
    <a href="./login" class="link">
      <div class="logo"></div>
    </a>
    <div class="action">
      <span class="action-label">Já tem uma conta?</span>

      <button id="btn-register-has-account-header" (click)="router.navigate(['/login'])"
        mat-stroked-button>Entrar</button>
    </div>
  </div>
  <div class="row form-row">
    <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-6 offset-lg-4 content-area"
      [ngSwitch]="currentStep">
      <div id="div-create-account-header" *ngIf="currentStep != stepEnum.FinalLoading && !showingError"
        class="form-header">
        <h1 class="form-title">Crie sua conta</h1>
        <br>
        <p *ngIf="isRanking">Forneça alguns dados sobre você, para criar a sua conta no Desafio de Investimentos.</p>
        <div class="form-subTitile mt-1" *ngIf="!isRanking">
          <mat-radio-group id="radio-group-type" class="btn-radio ml-3" *ngFor="let item of registerTypesRadio"
            [(ngModel)]="selectedRegistrationType">
            <mat-radio-button id="radio-button-{{item.type}}" class="radio-button mr-1" [value]="item.type"
              (click)="selectType(item.type)">{{ item.title }}
            </mat-radio-button>
          </mat-radio-group>
          <div class="mt-1">{{ selectedRegistrationMessage }}</div>
        </div>
      </div>
      <form id="form-register" [formGroup]="registerForm">
        <mat-progress-bar *ngIf="currentStep != stepEnum.RegisterType && currentStep != stepEnum.FinalLoading"
          class="progress-bar" [mode]="progressBarMode" [value]="getProgressBarPercent()">
        </mat-progress-bar>
        <div formGroupName="partner" class="form-content partner" *ngSwitchCase="stepEnum.PartnerBrokerage">
          <ng-container *ngIf="!loadingBrokers else fastLoading">
            <ng-container *ngIf="brokeragePartners.length > 0 else genericError">
              <div class="row mt-1">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>Selecione uma corretora</mat-label>
                    <mat-select id="select-broker" panelClass="custom-register-select" formControlName="broker"
                      (selectionChange)="onBrokerChange($event)">
                      <mat-option id="option-broker-{{item.broker}}" class="brokers-list-item custom-register-option"
                        *ngFor="let item of brokeragePartners" [value]="item.broker">
                        {{item.description}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="registerFormPartnerGroup.controls['broker'].hasError('required')">
                      Campo obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <ng-container *ngIf="brokerHasSinacor else sinacorError">
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>Nome completo</mat-label>
                      <input id="firstname" matInput onlyLetters trim formControlName="name" maxlength="60">
                      <mat-error *ngIf="registerFormPartnerGroup.controls['name'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                      <mat-error
                        *ngIf="registerFormPartnerGroup.controls['name'].hasError('invalidName') && !registerFormPartnerGroup.controls['name'].hasError('required')">
                        Por favor, informe seu nome completo
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>CPF</mat-label>
                      <input id="input-has-broker-cpf" type="tel" cpfMask maxlength="14" matInput formControlName="cpf">
                      <mat-error *ngIf="registerFormPartnerGroup.controls['cpf'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                      <mat-error
                        *ngIf="registerFormPartnerGroup.controls['cpf'].hasError('invalidCPF') && !registerFormPartnerGroup.controls['cpf'].hasError('required')">
                        CPF Inválido
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>Número da conta (sem o dígito)</mat-label>
                      <input id="input-has-broker-account" OnlyNumber matInput maxlength="7" formControlName="account">
                      <mat-error *ngIf="registerFormPartnerGroup.controls['account'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span>Você é investidor profissional?</span>
                    <ng-container *ngTemplateOutlet="customTooltip"></ng-container>
                    <div class="row mt-1 mb-1">
                      <div class="col">
                        <mat-radio-group id="radio-button-has-broker-is-professional" class="btn-radio"
                          formControlName="is_professional">
                          <mat-radio-button class="radio-button mr-1" [value]="true"
                            id="radio-button-has-broker-is-professional-true">
                            Sim
                          </mat-radio-button>
                          <mat-radio-button class="radio-button ml-1" [value]="false"
                            id="radio-button-has-broker-is-professional-false">
                            Não
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <mat-checkbox name="accept-terms" class="acept-term" formControlName="acepted_term">
                      Li e concordo com os <a href="https://plataformafasttrade.com.br/politica-de-privacidade/"
                                              target="_blank">termos e condições de uso</a>.
                    </mat-checkbox>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div formGroupName="profile" class="form-content" *ngSwitchCase="stepEnum.PersonalInformation">
          <div class="row mt-1">
            <div class="col">
              <mat-form-field appearance="outline" *ngIf="showFormIntegrator && selectedRegistrationType == 2">
                <mat-label>Selecione uma corretora</mat-label>
                <mat-select id="select-broker" panelClass="custom-register-select" formControlName="broker"
                  (selectionChange)="onBrokerChange($event)">
                  <mat-option id="option-broker-{{item.broker}}" class="brokers-list-item custom-register-option"
                    *ngFor="let item of brokeragePartners" [value]="item.broker">
                    {{item.description}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="registerFormProfileGroup.controls['broker'].hasError('required')">
                  Campo obrigatório
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row" [ngClass]="{'mt-1': !showFormIntegrator}">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Nome completo</mat-label>
                <input id="firstname" onlyLetters trim matInput formControlName="name" maxlength="60" required>
                <mat-error *ngIf="registerFormProfileGroup.controls['name'].hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-error *ngIf="registerFormProfileGroup.controls['name'].hasError('invalidName')
                  && !registerFormProfileGroup.controls['name'].hasError('required')">
                  Por favor, informe seu nome completo
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>CPF</mat-label>
                <input id="input-register-cpf" type="tel" cpfMask maxlength="14" matInput formControlName="cpf"
                  required>
                <mat-error *ngIf="registerFormProfileGroup.controls['cpf'].hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-error
                  *ngIf="registerFormProfileGroup.controls['cpf'].hasError('invalidCPF') && !registerFormProfileGroup.controls['cpf'].hasError('required')">
                  CPF Inválido
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Endereço de e-mail</mat-label>
                <input id="email" emailMask matInput formControlName="email" type="email" maxlength="60" required>
                <mat-error *ngIf="registerFormProfileGroup.controls['email'].hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-error
                  *ngIf="registerFormProfileGroup.controls['email'].hasError('email') && !registerFormProfileGroup.controls['email'].hasError('required')">
                  E-mail inválido
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field class="phone-number" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input id="phone" type="tel" phoneMask matInput formControlName="phone">
                <span matPrefix>+55 </span>
                <mat-error *ngIf="registerFormProfileGroup.controls['phone'].hasError('invalidPhone')">
                  Telefone inválido
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="selectedRegistrationType !== 2 || showFormIntegrator">
            <div class="col">
              <mat-form-field class="birth-date" id="birth-date" appearance="outline">
                <mat-label>Data de Nascimento</mat-label>
                <input appDatepickerMask customDateMask matInput [matDatepicker]="picker" autocomplete="false"
                  formControlName="birth_date" required>
                <mat-datepicker-toggle matSuffix [for]="picker" required></mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false" required></mat-datepicker>
                <mat-error *ngIf="registerFormProfileGroup.controls['birth_date'].hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-error *ngIf="registerFormProfileGroup.controls['birth_date'].hasError('invalidAge')">
                  {{ underageError }}
                </mat-error>
                <mat-error *ngIf="registerFormProfileGroup.controls['birth_date'].hasError('invalidDate')">
                  {{ invalidDateError }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="selectedRegistrationType == 3" class="row">
            <div class="col">
              <span>Você é investidor profissional?</span>
              <ng-container *ngTemplateOutlet="customTooltip"></ng-container>
              <div class="row mt-1 mb-1">
                <div class="col">
                  <mat-radio-group id="radio-professional-investor" class="btn-radio" formControlName="is_professional">
                    <mat-radio-button class="radio-button mr-1" [value]="true" id="radio-is-professional-true">
                      Sim
                    </mat-radio-button>
                    <mat-radio-button class="radio-button  ml-1" [value]="false" id="radio-is-professional-false">
                      Não
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="form-address" formGroupName="address" class="form-content cep" *ngSwitchCase="stepEnum.Address">
          <mat-icon id="btn-address-back" (click)="goBack()" svgIcon="arrow-left"></mat-icon>
          <span>Agora precisamos do seu endereço a Bolsa exige estes dados no cadastro.</span>
          <div class="row mt-1">
            <div class="col zip-code">
              <mat-form-field appearance="outline">
                <mat-label>CEP</mat-label>
                <input id="input-address-zip-code" type="tel" id="zip_code" cepMask maxlength="9" matInput
                  formControlName="zip_code" (keyup.enter)="getAddress()" (keydown.tab)="getAddress()">
                <div id="btn-zip-code" (click)="getAddress()" class="suffix" matSuffix>OK</div>
                <mat-error *ngIf="registerFormGroupAddress.controls['zip_code'].hasError('required')">
                  Campo obrigatório
                </mat-error>
              </mat-form-field>
              <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank">
                Não sei meu CEP
              </a>
            </div>
          </div>
          <div *ngIf="!loadingCep else fastLoading">
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Endereço</mat-label>
                  <input id="input-address" trim matInput onlyLettersAndNumbers formControlName="address" minlength="3"
                    maxlength="60">
                  <mat-error *ngIf="registerFormGroupAddress.controls['address'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input id="number" type="tel" matInput OnlyNumber formControlName="number" maxlength="8">
                </mat-form-field>
              </div>
            </div>


            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Bairro</mat-label>
                  <input id="input-adreess-neighborhood" trim matInput onlyLetters formControlName="neighborhood"
                    minlength="3" maxlength="30">
                  <mat-error *ngIf="registerFormGroupAddress.controls['neighborhood'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Bairro (onlyLetters) </mat-label>
                  <input id="input-adreess-neighborhood" trim matInput onlyLetters formControlName="neighborhood"
                  minlength="3" maxlength="30">
                  <mat-error *ngIf="registerForm.controls['address'].controls['neighborhood'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div> -->


            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Cidade</mat-label>
                  <input id="input-address-city" trim matInput onlyLetters formControlName="city" minlength="3"
                    maxlength="30">
                  <mat-error *ngIf="registerFormGroupAddress.controls['city'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Estado</mat-label>
                  <mat-select formControlName="state">
                    <mat-option *ngFor="let state of countryStates" [value]="state?.abbreviation">
                      {{ state?.name }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="registerFormGroupAddress.controls['state'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-checkbox name="accept-terms" class="acept-term" formControlName="acepted_term">
                Li e concordo com os <a href="https://plataformafasttrade.com.br/politica-de-privacidade/"
                                        target="_blank">termos e condições de uso</a>.
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div id="form-password" formGroupName="password" class="form-content" *ngSwitchCase="stepEnum.Password">
          <mat-icon id="btn-address-back" (click)="goBack()" svgIcon="arrow-left"></mat-icon>
          <span>Agora defina sua senha para login no Fast Trade.</span>
          <div class="row mt-3">
            <div class="col">
              <div class="snack-bar" #snackBar></div>
              <mat-form-field class="password-type-input" appearance="outline">
                <mat-label>Senha</mat-label>
                <input id="input-password" #password type="password"
                  (keyup)="validatorPassword(registerFormPasswordGroup.controls['password'].value)" matInput
                  formControlName="password" minlength="0" maxlength="255">
                <span (click)="changePasswordVisibility(password)" class="show-hide-password-toggle" matSuffix>
                  {{ password.type === 'text' ? 'ocultar': 'mostrar'}}
                </span>
                <mat-error *ngIf="registerFormPasswordGroup.controls['password'].hasError('required')">
                  Campo obrigatório
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field class="password-type-input" appearance="outline">
                <mat-label>Confirmar senha</mat-label>
                <input id="input-confirmation" #confirmation type="password"
                  (keyup)="validatorConfirmation(registerFormPasswordGroup.controls['confirmation'].value)"
                  matInput formControlName="confirmation">
                <span (click)="changePasswordVisibility(confirmation)" class="show-hide-password-toggle" matSuffix>
                  {{ confirmation.type === 'text' ? 'ocultar': 'mostrar'}}
                </span>
                <mat-error *ngIf="registerFormPasswordGroup.controls['confirmation'].hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-error
                  *ngIf="registerFormPasswordGroup.controls['confirmation'].hasError('invalid_confirmation')">
                  As senhas devem ser iguais
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 complexy-password password-params">
              <div class="row">
                <div class="col-12 bold t-left">Padrão de senha:</div>
                <div class="col-6 p-0 t-left">
                  <div>
                    <mat-icon *ngIf="passwordComplexyLength" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordComplexyLength" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordComplexyLength }">Pelo menos 8 caracteres</span>
                  </div>
                  <div>
                    <mat-icon *ngIf="passwordComplexyLetterUp" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordComplexyLetterUp" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordComplexyLetterUp }">Use letras maiúscula (A-Z)</span>
                  </div>
                  <div>
                    <mat-icon *ngIf="passwordComplexySpecial" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordComplexySpecial" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordComplexySpecial }">Um caractere especial exceto(&?=#%)</span>
                  </div>
                </div>
                <div class="col-6 p-0 t-left">
                  <div>
                    <mat-icon *ngIf="passwordComplexyLetterDown" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordComplexyLetterDown" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordComplexyLetterDown }">Uma letra minúscula (a-z)</span>
                  </div>
                  <div>
                    <mat-icon *ngIf="passwordComplexyNumber" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordComplexyNumber" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordComplexyNumber }">Um número de (0-9)</span>
                  </div>

                  <!-- TODO: Verificar se vai mandar indicador desta "regra" -->
                  <!-- <div>
                    <mat-icon *ngIf="passwordEqualConfirmation" svgIcon="success-password"></mat-icon>
                    <mat-icon *ngIf="!passwordEqualConfirmation" svgIcon="success-password-disable"></mat-icon>
                    <span [ngClass]="{'valid': passwordEqualConfirmation }">As senhas devem ser iguais</span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="div-creating-account" class="form-content final-loading" *ngSwitchCase="stepEnum.FinalLoading">
          <ng-container *ngIf="!showingError else genericError">
            <span class="form-title">Estamos criando sua conta</span>
            <br>
            <span>Estamos fazendo alguns ajustes finais
            </span>
            <ng-container *ngTemplateOutlet="fastLoading"></ng-container>
          </ng-container>
        </div>
      </form>
      <div *ngIf="currentStep != stepEnum.FinalLoading && !showingError && brokerHasSinacor" class="form-footer">
        <button id="btn-form-valid-next" type="submit" *ngIf="currentStep != stepEnum.RegisterType" (click)="next()"
          [disabled]="!isFormValid()" mat-stroked-button>Próximo</button>
        <br>
        <span> Já tem uma conta? <a id="link-login-has-account" href="./login">Faça login</a></span>
      </div>
      <div class="contact">
        <span>Em caso de dúvidas, entre em contato no WhatsApp
          <a id="link-whatsapp-contact" href="https://api.whatsapp.com/send?phone=553432390003&text=Olá!"
            target="_blank"> (34) 3239-0003</a>
        </span>
      </div>
    </div>
  </div>
  <ng-template #fastLoading>
    <div class="animated-loading">
<!--      <lottie-animation-view [options]="lottieConfig" [width]="80" [height]="80">-->
<!--      </lottie-animation-view>-->
      <ng-lottie width="80px" [options]="optionsLottie"></ng-lottie>
    </div>
  </ng-template>
  <ng-template #genericError>
    <div id="div-general-error" class="general-error">
      <div class="row">
        <div class="col">
          <span id="span-error-title" class="title">{{errorTitle}}</span>
        </div>
      </div>
      <div class="row mt-1 mb-1">
        <div class="col description" id="span-error-description" [innerHTML]="errorDescription">

        </div>
      </div>
      <div class="row">
        <div class="col">
          <button id="btn-error-back" class="btn bo-back" (click)="goBack()"
            mat-stroked-button>{{errorRetryBtnText}}</button>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col">
          <button id="btn-error-call-help" class="btn help" (click)="callHelp()" mat-stroked-button>FALE COM A
            GENTE</button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #sinacorError>
    <div id="div-sinacor-error" class="sinacor-error">
      <div class="row">
        <div class="col">
          <span id="span-sinacor-error-title" class="title">
            {{ sinacorErrorTitle }}
          </span>
        </div>
      </div>
      <div class="row mt-1 mb-1">
        <div class="col">
          <span id="span-sinacor-error-description" class="description">
            {{ sinacorErrorDescription }}
          </span>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col">
          <button class="btn help" id="btn-call-help" (click)="callHelp()" mat-stroked-button>FALE COM A GENTE</button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #customTooltip>
    <mat-icon id="custom-tooltip" class="custom-tooltip" svgIcon="help">
      <div class="tooltip-content" id="customTooltip">
        <span id="spam-custom-tooltip-title" class="tooltip-title">São considerados investidores profissionais:</span>
        <hr>
        <span id="spam-custom-tooltip-content">Pessoas naturais que possuam investimentos financeiros em valor superior
          a R$ 10.000.000,00
          (dez milhões de reais).</span>
        <br>
        <span class="mt-1" id="spam-custom-tooltip-content-2">Agentes autônomos de investimento, administradores de
          carteira, analistas e consultores de
          valores mobiliários autorizados pela CVM.</span>
      </div>
    </mat-icon>
  </ng-template>
</div>
